import * as yup from "yup";

export interface ISearchUser {
    user?: string;
    phone?: string;
}

export const schemaSearchUser = yup.object().shape({
    user: yup
        .string(),
    phone: yup
        .string()
});
